import './About.css';
import { IconHandshake } from './Icons';

function About() {
  return (
    <section id="sobre" className="section-padding bg-dark-section about-section" aria-labelledby="about-title">
      <div className="container">
        <div className="row align-items-center g-5">
          <div className="col-lg-5">
            <span className="section-badge">01</span>
            <p className="section-title">Quem Somos</p>
            <h2 id="about-title" className="section-heading">
              Tr Silva Bueno <span className="text-accent">Transportes</span>
            </h2>
            <div className="red-divider" />
            <p className="about-text">
              Somos referência no mercado nacional para transporte de cargas lotação,
              com atuação em <strong>100% do território brasileiro</strong>. Desde 2015,
              unimos experiência, tecnologia e compromisso para entregar resultados
              consistentes aos nossos clientes.
            </p>
            <p className="about-text">
              Com sede em <strong>Curitiba — Paraná</strong>, expandimos nossa operação
              com hub de armazenagem e infraestrutura logística, oferecendo soluções
              integradas em transporte e depósito de carga.
            </p>
            <div className="about-meta">
              <span>CNPJ 22.430.496/0001-76</span>
              <span>Fundada em 12/05/2015</span>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="about-visual">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/caminhao.png`}
                alt="Frota Tr Silva Bueno em operação"
                className="about-image"
                loading="lazy"
              />
              <div className="about-visual-badge">
                <div className="icon-circle">
                  <IconHandshake />
                </div>
                <p>Parceria de confiança em logística</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
